//imports
import Headroom from "headroom.js";
import GLightbox from 'glightbox';
import Lenis from 'lenis';
import 'slick-carousel';
import AOS from 'aos';
import Rellax from 'rellax';
import Tick from '@pqina/flip';


// lazysizes
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';



$(document).ready(function($){

   
if (document.querySelector('.tick')) {
  // see Tick API in console
  console.log(Tick);

  // create visual counter
  Tick.DOM.create(document.querySelector('.tick'), {
    didInit: function (tick) {
      // create the countdown counter
      var nextYear = new Date().getFullYear() + 1;
      var counter = Tick.count.down(nextYear + "-01-01T00:00:00+01:00");

      var locale = {
        YEAR_PLURAL: 'Jahre',
        YEAR_SINGULAR: 'Jahr',
        MONTH_PLURAL: 'Monate',
        MONTH_SINGULAR: 'Monat',
        WEEK_PLURAL: 'Wochen',
        WEEK_SINGULAR: 'Woche',
        DAY_PLURAL: 'Tage',
        DAY_SINGULAR: 'Tag',
        HOUR_PLURAL: 'Stunden',
        HOUR_SINGULAR: 'Stunde',
        MINUTE_PLURAL: 'Minuten',
        MINUTE_SINGULAR: 'Minute',
        SECOND_PLURAL: 'Sekunden',
        SECOND_SINGULAR: 'Sekunde',
        MILLISECOND_PLURAL: 'Millisekunden',
        MILLISECOND_SINGULAR: 'Millisekunde'
      };

      for (var key in locale) {
        if (!locale.hasOwnProperty(key)) continue;
        tick.setConstant(key, locale[key]);
      }

      counter.onupdate = function (value) {
        console.log('onupdate', value);
        tick.value = value;
      };

      counter.onended = function () {
        console.log('onended');
      };

      console.log('initialized');
    },
  });
}

    var rellax = new Rellax('.rellax');

  // jQuery-Version (kompakt)
$('.faq__item').each(function () {
  const $d = $(this);                          // <details>
  const $q = $d.find('.faq__question').first(); // <summary>
  const $a = $d.find('.faq__answer').first();   // Antwort-Container

  if (!$q.length || !$a.length) return;

  // Initialzustand
  if ($d.prop('open')) {
    $a.show().css('opacity', 1);
  } else {
    $a.hide().css('opacity', 0);
  }

  // Click/Tap
  $q.on('click', function (e) {
    e.preventDefault(); // verhindert das native <details>-Toggle
    if (!$d.prop('open')) {
      $d.prop('open', true);                    // State sichtbar (Icon etc.)
      $a.stop(true, true).css('opacity', 1).slideDown(280);
    } else {
      $a.stop(true, true).slideUp(280, function () {
        $a.css('opacity', 0);
        $d.prop('open', false);
      });
    }
  });

  // Tastatur-Unterstützung, falls <summary> nicht reicht/ersetzt wurde
  if (!/summary/i.test($q[0].tagName)) {
    $q.attr({ role: 'button', tabindex: 0 }).on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $q.click(); }
    });
  }
});






  // Initialize Lenis
const lenis = new Lenis({
    autoRaf: true,
  anchors: {
    offset: 0,
    onComplete: ()=>{
      console.log('scrolled to anchor')
    }
  }
})

window.lenis = lenis;

// Listen for the scroll event and log the event data
lenis.on('scroll', (e) => {
  console.log(e);
    if (e.scroll > 1) {
    document.body.classList.add('scrolled');
  } else {
    document.body.classList.remove('scrolled');
  }
});


     
  

  //GLIGHTBOX
 const lightbox = GLightbox();

  var options = {

     offset: {
         up: 0,
         down: 0
     },
     // scroll tolerance in px before state changes
     tolerance : 0,

 };

 //HEADROOM JS
  var element = document.querySelector("header");
  var headroom  = new Headroom(element,options);
  // initialise
  headroom.init();

  //AOS
  AOS.init();


  //SLICK SLIDER
$('.slider__holder').slick({
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    arrows: false,
  });

  $('.next').click(() => $('.slider__holder').slick('slickNext'));
  $('.prev').click(() => $('.slider__holder').slick('slickPrev'));

   



});







// Accessible Burger Menu (standalone)
// Erwartet HTML-Struktur:
// <nav id="site-navigation">
//   <button class="menu-toggle" aria-expanded="false" aria-controls="primary-menu">Menü</button>
//   <ul id="primary-menu" class="menu">
//     ...
//   </ul>
// </nav>

// Accessible Burger Menu (standalone)
// Erwartet HTML-Struktur:
// <nav id="site-navigation">
//   <button class="menu-toggle" aria-expanded="false" aria-controls="primary-menu">Menü</button>
//   <ul id="primary-menu" class="menu">
//     ...
//   </ul>
// </nav>

// Accessible burger with Lenis lock + ESC to close
(function initAccessibleBurger() {
  const siteNavigation = document.getElementById('site-navigation');
  if (!siteNavigation) return;

  const button = siteNavigation.querySelector('button');
  const menu   = siteNavigation.querySelector('ul');
  if (!button || !menu) return;

  // Lenis global holen
  const lenisInstance = window.lenis || (typeof lenis !== 'undefined' ? lenis : null);

  function openNav() {
    siteNavigation.classList.add('toggled');
    document.body.classList.add('stop-scrolling'); // <-- Body Class rein
    button.setAttribute('aria-expanded', 'true');

 
 
      lenis.stop();
  

    // ESC aktivieren
    document.addEventListener('keydown', escClose);
  }

  function closeNav() {
    siteNavigation.classList.remove('toggled');
    document.body.classList.remove('stop-scrolling'); // <-- Body Class raus
    button.setAttribute('aria-expanded', 'false');

      lenis.start();
    
    document.removeEventListener('keydown', escClose);
  }

  function escClose(e) {
    if (e.key === 'Escape') {
      closeNav();
    }
  }

  // Button Toggle
  button.addEventListener('click', (e) => {
    e.stopPropagation();
    if (siteNavigation.classList.contains('toggled')) {
      closeNav();
    } else {
      openNav();
    }
  });

  // Close on link click
  menu.addEventListener('click', (e) => {
    if (e.target.closest('a')) {
      closeNav();
    }
  });

  // Click outside closes
  document.addEventListener('click', (e) => {
    if (!siteNavigation.contains(e.target) && siteNavigation.classList.contains('toggled')) {
      closeNav();
    }
  });
})();




const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

function animateDonut(el){
  const strong   = el.querySelector('strong');
  const small    = el.querySelector('small');

  const target   = clamp(Number(el.dataset.percent || 0), 0, 100);
  const delay    = Number(el.dataset.delay || 0);
  const duration = reduce ? 0 : Number(el.dataset.duration || 900);

  const aLabel   = el.dataset.a || 'A';
  const bLabel   = el.dataset.b || 'B';
  small.textContent = `${aLabel}`;

  const t0 = performance.now() + delay;
  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

  function tick(now){
    if(now < t0){ requestAnimationFrame(tick); return; }
    const k = duration ? Math.min(1, (now - t0) / duration) : 1;
    const e = reduce ? 1 : easeOutCubic(k);

    const v = target * e;
    el.style.setProperty('--p', v);
    strong.textContent = `${Math.round(v)}%`;

    if(k < 1 && !reduce) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

function clamp(n, min, max){ return Math.min(max, Math.max(min, n)); }

// alle Donuts animieren
document.querySelectorAll('.donut').forEach(animateDonut);
